// English last-resort floor for the strings that must render even when the
// server dictionary is unavailable (still loading, or failed): the
// translations-failed error boundary and the Narvar footer. In normal
// operation the server dictionary wins (resolveTranslations layers it OVER
// this seed); pdp-graphql injects these same keys server-side per locale and
// non-overridably (see config/businessTranslations.ts), so this seed is purely
// the offline English fallback. Keys are lowercase to match rawString's lookup.
export const seedTranslations: Record<string, string> = {
  'pdx.error.boundary.title': 'Something went wrong!',
  'pdx.global.correlation_id': 'Correlation ID: {{correlation_id}}',
  'pdx.global.footer.copyright': '©{{year}} Narvar',
  'pdx.global.footer.powered_by': 'Powered by Narvar',
  'pdx.global.footer.privacy_policy': 'Privacy Policy',
  'pdx.global.footer.privacy_policy_url':
    'https://corp.narvar.com/privacy-policy/',
};
